import { Controller, useFormContext } from 'react-hook-form';

import {
  employerPhoneNumberValidationMessage,
  IncomeSourceFormT,
  phoneNumberRules,
} from '@consumer-frontend/nc-utils';

import { NcIncomeSourceAmountField } from './NcIncomeSourceAmountField';
import { NcInput } from '../NcInput';
import { NcPhoneInput } from '../NcPhoneInput';

const companyNameValidations = {
  required: 'Enter the name of the company where you work.',
};

const jobTitleValidations = {
  required: 'Enter your current job title.',
};

const employerPhoneNumberValidations = phoneNumberRules(employerPhoneNumberValidationMessage);

export type NcIncomeSourceEmployedFormPropsT = {
  showAmountField?: boolean;
};

export type NcIncomeSourceEmployedFormT = React.FC<NcIncomeSourceEmployedFormPropsT>;

export const NcIncomeSourceEmployedForm: NcIncomeSourceEmployedFormT = ({
  showAmountField = false,
}) => {
  const {
    control,
    formState: { errors },
    register,
  } = useFormContext<IncomeSourceFormT>();

  return (
    <>
      <NcInput
        {...register('employment.employer', companyNameValidations)}
        autoComplete="organization"
        errorMessage={errors.employment?.employer?.message}
        id="companyName"
        label="Company Name"
        type="text"
      />
      <NcInput
        {...register('employment.title', jobTitleValidations)}
        autoComplete="organization-title"
        errorMessage={errors.employment?.title?.message}
        id="jobTitle"
        label="Job Title"
        type="text"
      />
      <Controller
        control={control}
        name="employment.phoneNumber"
        rules={employerPhoneNumberValidations}
        render={({ field }) => (
          <NcPhoneInput
            {...field}
            errorMessage={errors.employment?.phoneNumber?.message}
            id="employerPhoneNumber"
            label="Employer Phone Number"
          />
        )}
      />

      {showAmountField && (
        <NcIncomeSourceAmountField label="Pay Per Paycheck (After Taxes)" />
      )}
    </>
  );
};
